// covered-by: frontends/carrie/src/routes/ask-puntt/__tests__/campaignRoute.test.ts
//
// Single source of truth for the ask-puntt campaign search params. Re-exported
// by ./campaignRoute (all call sites import it from there), and read as source
// text by rembrandt's cross-layer contract tests
// (services/rembrandt/tests/test_review_agent.py + test_review_service_run.py),
// which assert this chatId normalization so the FE token stays in lockstep with
// the review pipeline. Keep it a named export that trims chatId and yields
// `undefined` for empty/whitespace — those tests fail loudly otherwise.
/** Search params for `campaignRoute` navigations (required by TanStack after validateSearch). */
export function campaignSearch(chatId?: string) {
  return { chatId: chatId?.trim() ? chatId.trim() : undefined };
}
